import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface BasePriceTypeState {
    showBasicPrice: boolean;
}

const initialState: BasePriceTypeState = {
    showBasicPrice: false,
};
const basePriceSlice = createSlice({
    name: 'basePriceType',
    initialState,
    reducers: {
        toggleBasePriceType: (state) => {
            state.showBasicPrice = !state.showBasicPrice;
        },
        setBasePriceType: (state, action: PayloadAction<boolean>) => {
            state.showBasicPrice = action.payload;
        },
    },
});

export const basePriceTypeSliceReducer = basePriceSlice.reducer;

export const { toggleBasePriceType, setBasePriceType } = basePriceSlice.actions;

export const selectBasePriceTypeSliceData = (state: RootState) =>
    state.basePriceType.showBasicPrice;
